// Mock product data with real product images
export const mockProducts = [
  // Smartphones
  {
    id: 1,
    name: "iPhone 15 Pro Max",
    description: "The most advanced iPhone with titanium design, A17 Pro chip, and professional camera system.",
    price: 1199,
    originalPrice: 1299,
    category: "mobiles",
    brand: "Apple",
    imageUrl: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=500&h=500&fit=crop",
      "https://images.unsplash.com/photo-1580910051074-3eb694886505?w=500&h=500&fit=crop",
      "https://images.unsplash.com/photo-1556656793-08538906a9f8?w=500&h=500&fit=crop"
    ],
    inStock: true,
    rating: 4.8,
    reviewCount: 1247,
    featured: true,
    specifications: {
      display: "6.7-inch Super Retina XDR",
      processor: "A17 Pro chip",
      storage: "256GB",
      camera: "48MP Main + 12MP Ultra Wide + 12MP Telephoto",
      battery: "Up to 29 hours video playback",
      os: "iOS 17"
    },
    features: [
      "Titanium design with textured matte glass back",
      "A17 Pro chip with 6-core GPU",
      "Pro camera system with 5x Telephoto zoom",
      "Action button for quick access to features",
      "USB-C connector",
      "Face ID for secure authentication"
    ]
  },
  {
    id: 2,
    name: "Samsung Galaxy S24 Ultra",
    description: "Premium Android flagship with S Pen, 200MP camera, and AI-powered features.",
    price: 1099,
    originalPrice: 1199,
    category: "mobiles",
    brand: "Samsung",
    imageUrl: "https://images.unsplash.com/photo-1574944985070-8f3ebc6b79d2?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1574944985070-8f3ebc6b79d2?w=500&h=500&fit=crop",
      "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=500&h=500&fit=crop"
    ],
    inStock: true,
    rating: 4.7,
    reviewCount: 892,
    featured: true,
    specifications: {
      display: "6.8-inch Dynamic AMOLED 2X",
      processor: "Snapdragon 8 Gen 3",
      storage: "256GB",
      camera: "200MP Main + 50MP Periscope + 12MP Ultra Wide + 10MP Telephoto",
      battery: "5000mAh with 45W fast charging",
      os: "Android 14 with One UI 6.1"
    }
  },
  {
    id: 3,
    name: "Google Pixel 8 Pro",
    description: "AI-powered photography and pure Android experience with Magic Eraser and Best Take.",
    price: 899,
    category: "mobiles",
    brand: "Google",
    imageUrl: "https://images.unsplash.com/photo-1556656793-08538906a9f8?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.6,
    reviewCount: 634,
    featured: false
  },

  // Laptops
  {
    id: 4,
    name: "MacBook Pro 16-inch M3 Max",
    description: "The most powerful MacBook Pro with M3 Max chip, perfect for professionals and creators.",
    price: 2499,
    originalPrice: 2699,
    category: "laptops",
    brand: "Apple",
    imageUrl: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=500&h=500&fit=crop",
      "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=500&h=500&fit=crop"
    ],
    inStock: true,
    rating: 4.9,
    reviewCount: 456,
    featured: true,
    specifications: {
      display: "16.2-inch Liquid Retina XDR",
      processor: "Apple M3 Max chip",
      memory: "32GB unified memory",
      storage: "1TB SSD",
      graphics: "40-core GPU",
      battery: "Up to 22 hours",
      ports: "3x Thunderbolt 4, HDMI, SDXC, MagSafe 3"
    }
  },
  {
    id: 5,
    name: "Dell XPS 15 OLED",
    description: "Premium Windows laptop with stunning OLED display and powerful performance for creators.",
    price: 1899,
    category: "laptops",
    brand: "Dell",
    imageUrl: "https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.5,
    reviewCount: 328,
    featured: true
  },
  {
    id: 6,
    name: "ASUS ROG Strix G16 Gaming",
    description: "High-performance gaming laptop with RTX 4070 and 165Hz display for ultimate gaming.",
    price: 1599,
    originalPrice: 1799,
    category: "laptops",
    brand: "Asus",
    imageUrl: "https://images.unsplash.com/photo-1603302576837-37561b2e2302?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.4,
    reviewCount: 267,
    featured: false
  },

  // Audio
  {
    id: 7,
    name: "Sony WH-1000XM5 Headphones",
    description: "Industry-leading noise canceling wireless headphones with exceptional sound quality.",
    price: 349,
    originalPrice: 399,
    category: "audio",
    brand: "Sony",
    imageUrl: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500&h=500&fit=crop",
      "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=500&h=500&fit=crop"
    ],
    inStock: true,
    rating: 4.7,
    reviewCount: 1834,
    featured: true,
    specifications: {
      type: "Over-ear wireless headphones",
      noiseCanceling: "Industry-leading Active Noise Canceling",
      battery: "Up to 30 hours with ANC",
      connectivity: "Bluetooth 5.2, NFC",
      drivers: "30mm dynamic drivers",
      weight: "250g"
    }
  },
  {
    id: 8,
    name: "AirPods Pro (2nd Gen)",
    description: "Apple's premium wireless earbuds with adaptive transparency and spatial audio.",
    price: 229,
    originalPrice: 249,
    category: "audio",
    brand: "Apple",
    imageUrl: "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.6,
    reviewCount: 2156,
    featured: true
  },

  // Wearables
  {
    id: 9,
    name: "Apple Watch Series 9",
    description: "The most advanced Apple Watch with Double Tap gesture and S9 chip.",
    price: 399,
    category: "wearables",
    brand: "Apple",
    imageUrl: "https://images.unsplash.com/photo-1551816230-ef5deaed4a26?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.8,
    reviewCount: 967,
    featured: true
  },
  {
    id: 10,
    name: "Samsung Galaxy Watch 6",
    description: "Advanced smartwatch with comprehensive health tracking and long battery life.",
    price: 299,
    originalPrice: 329,
    category: "wearables",
    brand: "Samsung",
    imageUrl: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.5,
    reviewCount: 543,
    featured: false
  },

  // Accessories
  {
    id: 11,
    name: "Anker PowerCore 10000 PD",
    description: "Ultra-compact portable charger with Power Delivery for fast charging.",
    price: 49,
    category: "accessories",
    brand: "Anker",
    imageUrl: "https://images.unsplash.com/photo-1609592806596-b43bada2f4b5?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.4,
    reviewCount: 1245,
    featured: false
  },
  {
    id: 12,
    name: "Logitech MX Master 3S Mouse",
    description: "Advanced wireless mouse with ultra-fast scrolling and multi-device connectivity.",
    price: 99,
    originalPrice: 119,
    category: "accessories",
    brand: "Logitech",
    imageUrl: "https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=500&h=500&fit=crop",
    inStock: true,
    rating: 4.7,
    reviewCount: 892,
    featured: true
  }
]

export const mockCategories = [
  { id: 'mobiles', name: 'Smartphones', slug: 'mobiles' },
  { id: 'laptops', name: 'Laptops', slug: 'laptops' },
  { id: 'audio', name: 'Audio', slug: 'audio' },
  { id: 'wearables', name: 'Wearables', slug: 'wearables' },
  { id: 'accessories', name: 'Accessories', slug: 'accessories' },
  { id: 'gaming', name: 'Gaming', slug: 'gaming' }
]

// Helper functions
export const getProductById = (id) => {
  return mockProducts.find(product => product.id === parseInt(id))
}

export const getProductsByCategory = (category) => {
  return mockProducts.filter(product => product.category === category)
}

export const getFeaturedProducts = () => {
  return mockProducts.filter(product => product.featured)
}

export const searchProducts = (query) => {
  const searchTerm = query.toLowerCase()
  return mockProducts.filter(product => 
    product.name.toLowerCase().includes(searchTerm) ||
    product.description.toLowerCase().includes(searchTerm) ||
    product.brand.toLowerCase().includes(searchTerm)
  )
}

export const filterProducts = (filters) => {
  let filteredProducts = [...mockProducts]

  if (filters.category) {
    filteredProducts = filteredProducts.filter(product => product.category === filters.category)
  }

  if (filters.brand) {
    filteredProducts = filteredProducts.filter(product => product.brand === filters.brand)
  }

  if (filters.minPrice) {
    filteredProducts = filteredProducts.filter(product => product.price >= parseFloat(filters.minPrice))
  }

  if (filters.maxPrice) {
    filteredProducts = filteredProducts.filter(product => product.price <= parseFloat(filters.maxPrice))
  }

  if (filters.search) {
    const searchTerm = filters.search.toLowerCase()
    filteredProducts = filteredProducts.filter(product => 
      product.name.toLowerCase().includes(searchTerm) ||
      product.description.toLowerCase().includes(searchTerm) ||
      product.brand.toLowerCase().includes(searchTerm)
    )
  }

  // Sort products
  if (filters.sortBy) {
    switch (filters.sortBy) {
      case 'price-low':
        filteredProducts.sort((a, b) => a.price - b.price)
        break
      case 'price-high':
        filteredProducts.sort((a, b) => b.price - a.price)
        break
      case 'rating':
        filteredProducts.sort((a, b) => (b.rating || 0) - (a.rating || 0))
        break
      case 'popularity':
        filteredProducts.sort((a, b) => (b.reviewCount || 0) - (a.reviewCount || 0))
        break
      case 'newest':
      default:
        // Keep original order for newest
        break
    }
  }

  return filteredProducts
}